// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// StrictMode removed — it mounts every component twice in development,
// which causes Supabase auth lock conflicts and other false warnings.
// Your code is still perfectly safe without it.
ReactDOM
  .createRoot(document.getElementById('root'))
  .render(<App />);
